import { IEsecutore } from './../interfaces/IEsecutore';
import { EsecutoreService } from './../services/esecutore.service';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import * as Enum from '../utils/enums'
import { Loading } from '../utils/loading';
import { CommessaService } from '../services/commessa.service';
import { RequestBuilder } from '../classes/request-builder';
import { finalize } from 'rxjs/operators';
import { ICommessa } from '../interfaces/ICommessa';
import { DialogService } from 'primeng/api';
import { CommessaModalComponent } from '../commessa-modal/commessa-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { AggiudicatarioService } from '../services/aggiudicatario.service';
import { IRichiesta } from '../interfaces/IRichiesta';
import { IDocumento } from '../interfaces/IDocumento';
import { RichiestaService } from '../services/richiesta.service';
import { RichiestaModalComponent } from '../richiesta-modal/richiesta-modal.component';
import { DocumentoModalComponent } from '../documento-modal/documento-modal.component';
import { AlertUtil } from '../utils/alert-util';
import { IStoricoRisposte } from '../interfaces/IStoricoRisposte';
import { DocumentiService } from '../services/documenti.service';
import * as Constants from '../utils/constants';
import { SendRichiestaModalComponent } from '../send-richiesta-modal/send-richiesta-modal.component';
import { Util } from '../utils/util';
import { FilieraService } from '../services/filiera.service';
import { ITipoRichiesta } from '../interfaces/ITipoRichiesta';
import { DataTableComponent } from '../data-table/data-table.component';
import { AssociaCommessaAGruppoModalComponent } from '../associa-commessa-agruppo-modal/associa-commessa-agruppo-modal.component';
import { NoteModalComponent } from '../note-modal/note-modal.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeComponent implements OnInit {

  commesse: ICommessa[]  // commesse table data source
  richieste: IRichiesta[] // richieste table data source
  documenti: IDocumento[] // documenti table data source

  commessaSelected: ICommessa // commessa selected from table
  richiestaSelected: IRichiesta // richiesta selected from table
  documentoSelected: IDocumento // documento selected from table

  richiestaTableSelectedItem: any //richiesta selected item

  DTT = Enum.DATA_TABLE_TYPE_ENUM //export enum for html
  L = Loading                     //export loading for html

  isAffidatario: boolean //determines whether the user logged is affidatario 
  isAdmin: boolean //determines whether the user logged is admin 
  isPrefetto: boolean //determines whether the user logged is prefetto 
  isAggiudicatario: boolean //determines whether the user logged is aggiudicatario 
  isCse: boolean //determines whether the user logged is cse
  disableRichiestaTooltip: boolean = true // show tooltip richiesta
  disableCommessaTooltip: boolean = true // show tooltip richiesta

  canCreateRichiesta: boolean = true //determines whether new richiesta can be created

  @ViewChild("dtRichieste") dtRichieste: DataTableComponent
  @ViewChild("dtDocumenti") dtDocumenti: DataTableComponent

  constructor(private commessaService: CommessaService, private aggiudicatarioService: AggiudicatarioService,
    private richiestaService: RichiestaService, private translate: TranslateService, private dialogService: DialogService,
    private documentiService: DocumentiService, private alertUtil: AlertUtil, private filieraService: FilieraService,
    private esecutoreService: EsecutoreService,
    private cd: ChangeDetectorRef) { }

  ngOnInit() {
    let userRole = localStorage.getItem(Constants.LS_USER_ROLE)
    this.checkUserRole(userRole)
    setTimeout(() => {
      this.getAllCommesse()
    }, 0);
  }

  /**
  * check role of user logged
  */
  checkUserRole(userRole: string) {
    if (userRole == Enum.USER_TYPE_ENUM.AMMINISTRATORE) {
      this.isAdmin = true
      this.disableRichiestaTooltip = true
      this.disableCommessaTooltip = false
    } else if (userRole == Enum.USER_TYPE_ENUM.AFFIDATARIO || userRole == Enum.USER_TYPE_ENUM.GVS) {
      this.isAffidatario = true
      this.disableRichiestaTooltip = false
      this.disableCommessaTooltip = true
    } else if (userRole == Enum.USER_TYPE_ENUM.AGGIUDICATARIO || userRole == Enum.USER_TYPE_ENUM.ESECUTORE) {
      this.isAggiudicatario = true
      this.disableRichiestaTooltip = true
      this.disableCommessaTooltip = false
    } else if (userRole == Enum.USER_TYPE_ENUM.PREFETTURA
      || userRole == Enum.USER_TYPE_ENUM.DL) {
      this.isPrefetto = true;
    } else if (userRole == Enum.USER_TYPE_ENUM.CSE) {
      this.isCse = true
      this.disableRichiestaTooltip = false
      this.disableCommessaTooltip = false
    }
  }

  /**
   * retrieve all commesse
   */
  getAllCommesse() {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder({})
    this.commessaService.getAllCommesse(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.commesse = response.data
          this.cd.markForCheck();
          //this.commesse.sort((a, b) { return a.count - b.count })  
          this.commesse.sort(({ count: a }, { count: b }) => b - a);// per ordinamento decrescente tabella
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
   * open commessa modal
   * @param commessa 
   */
  callServiceAndOpenCommessaModal(commessa?: ICommessa) {
    Loading.isLoading = true
    //get all aggiudicatari
    this.aggiudicatarioService.getAllAggiudicatari().pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.cd.markForCheck();
          //get header translation
          this.openModalCommessa(commessa, response);
        }
        else if (response.error) {

        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      }
    )
  }

  private openModalCommessa(commessa: ICommessa, response: any) {
    this.translate.get(["LBL_NEW_COMMESSA", "LBL_UPDATE_COMMESSA"]).subscribe(res => {
      //open commessa modal
      let commessaModal = this.dialogService.open(CommessaModalComponent, {
        data: {
          commessa: commessa,
          aggiudicatari: response.data
        },
        header: commessa ? res["LBL_UPDATE_COMMESSA"] : res["LBL_NEW_COMMESSA"],
        width: '50%'
      });

      // refresh commesse when modal is closed and newCommessa is created
      commessaModal.onClose.subscribe((newCommessa) => {
        if (newCommessa) {
          this.getAllCommesse();
        }
      });
    });
  }

  /**
   * callback fired when delete btn of intervento
   * @param commessa 
   */
  onDeleteCommessa(commessa: ICommessa) {
    // intervento delete
    this.alertUtil.showConfirmationAlert("LBL_DELETE_COMMESSA_CONFIRMATION", null, null, null, null, () => {
      Loading.isLoading = true
      let reqBuilder = new RequestBuilder({ Id: commessa.Id })
      this.commessaService.deleteCommessa(reqBuilder).subscribe(
        response => {
          Loading.isLoading = false
          if (response.data) {
            this.cd.markForCheck();
            this.onCommessaRowUnselected()
            this.alertUtil.showAlert('LBL_DELETE_COMMESSA', null, null, null, () => {
              this.getAllCommesse()
            })
          } else if (response.error) {
            let errorKey = "LBL_ERROR_" + response.error.Code
            this.alertUtil.showErrorAlert(errorKey)
            console.log("ERROR: " + response.error.Stack)
          } else {
            this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
          }
        },
        error => {
          Loading.isLoading = false
          let errorKey = "LBL_HTTP_ERROR_0"
          if (error.status) {
            errorKey = "LBL_HTTP_ERROR_" + error.status
          }
          this.alertUtil.showErrorAlert(errorKey)
        })
    })
  }

  /**
   * callback fired when one commessa row is selected
   * @param commessa
   */
  onCommessaRowSelected(commessa: ICommessa) {
    this.commessaSelected = commessa
    this.saveAggiudicatarioLS(commessa);
    this.onRichiestaRowUnselected()
    Loading.isLoading = true
    let requestBuilder = new RequestBuilder({ Id: commessa.Id })
    this.commessaService.getRichiesteCommessa(requestBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.cd.markForCheck();
          //Resets sort, filter and paginator state.
          this.dtRichieste.resetTable()

          this.richieste = response.data.Richieste
          // set Cantiere from commessa response to commessaSelected
          this.commessaSelected.Cantieri = response.data.Cantieri
          //check commessa status
          this.checkRichiestaCreation()
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
   * salvataggio Aggiudicatario in LS 
   * @param commessa 
   */
  private saveAggiudicatarioLS(commessa: ICommessa) {
    if (commessa.Aggiudicatario) {
      localStorage.setItem(Constants.LS_AGGIUDICATARIO, JSON.stringify(commessa.Aggiudicatario));
    }
  }

  /**
   * callback fired when one commessa row is unselected
   */
  onCommessaRowUnselected() {
    this.commessaSelected = null
    this.richiestaSelected = null
    this.documentoSelected = null
  }

  /**
   * fetch for modal Richiesta
   */
  fetchForRichiestaModal() {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder(null, ["TipiContratto"])
    // retrieve all tipi richiesta for new richiesta
    this.richiestaService.getAllTipiRichiesta(reqBuilder).pipe(finalize(() => {
    })).subscribe(
      response => {
        if (response.data) {//response ok
          this.cd.markForCheck();
          this.getAllEsecutori(response.data)
        }
        else if (response.error) {//response ko
          Loading.isLoading = false
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          Loading.isLoading = false
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        Loading.isLoading = false
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
   * callback fired when one richiesta row is selected
   * @param richiesta
   */
  onRichiestaRowSelected(richiesta: IRichiesta) {
    this.richiestaSelected = richiesta
    this.callRichiestaFetchSingle(this.richiestaSelected)
  }

  /**
   * call richiesta fetch single for documenti datatable
   */
  callRichiestaFetchSingle(richiesta: IRichiesta, callback?: any) {
    Loading.isLoading = true
    //AGGIUNTO IL PATH ESECUTORE PER FAR RESTITUIRE I DATI DELL'ESECUTORE
    let requestBuilder = new RequestBuilder({ Id: richiesta.Id }, ["StoricoModuli.StoricoRisposte", "StoricoModuli.MatriceModulo.MatriceDomande", "StoricoModuli.Allegati", "Esecutore"])
    this.richiestaService.getRichiestaData(requestBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.cd.markForCheck();
          if (callback) {
            callback(response.data.StoricoModuli)
          }
          else {
            //Resets sort, filter and paginator state.
            this.dtDocumenti.resetTable()

            this.documenti = response.data.StoricoModuli
            if (response.data && response.data.Esecutore) {
              localStorage.setItem(Constants.LS_ESECUTORE, JSON.stringify(response.data.Esecutore))
            }

            // this.handleDocumentiRead()
          }
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
   * callback fired when one richiesta row is unselected
   */
  onRichiestaRowUnselected() {
    this.richiestaSelected = null
    this.documentoSelected = null
  }

  /**
   * callback fired when one documento row is selected
   * @param documento
   */
  onDocumentoRowSelected(documento: IDocumento) {
    this.documentoSelected = documento
    this.createCustomResponse()
    this.openDocumentoModal(this.documentoSelected)
  }

  /**
   * callback fired when one documento row is unselected
   */
  onDocumentoRowUnselected() {
    this.documentoSelected = null
  }

  /**
   * open documento modal
   * @param documento 
   */
  openDocumentoModal(documento: IDocumento) {
    //open aggiudicatari modal
    let documentoModal = this.dialogService.open(DocumentoModalComponent, {
      data: { documento, richiesta: this.richiestaSelected },
      header: documento.Nome,
      width: '80%'
    })

    // refresh aggiudicatari when modal is closed and newAggiudicatario is created
    documentoModal.onClose.subscribe((documentoObj) => {
      // if (documentoObj) { force refresh 
      this.callRichiestaFetchSingle(this.richiestaSelected)
      this.onDocumentoRowUnselected()
      // }
    })
  }

  /**
   * Handle send richiesta to affidatario o prefettura
   * @param richiesta 
   */
  onSendRichiesta(richiesta: IRichiesta) {
    let role = localStorage.getItem(Constants.LS_USER_ROLE)
    //when aggiudicatario/GVS/CSE open modal for choise type of send
    if (role == Enum.USER_TYPE_ENUM.AFFIDATARIO
      || role == Enum.USER_TYPE_ENUM.GVS
      || role == Enum.USER_TYPE_ENUM.CSE) {
      if (!this.richiestaSelected || this.richiestaSelected.Id != richiesta.Id) {
        this.callRichiestaFetchSingle(richiesta, (documenti: IDocumento[]) => {
          this.openSendRichiestaModal(richiesta, documenti)
        })
      }
      else {
        this.openSendRichiestaModal(richiesta, this.documenti)
      }

    } else if (role == Enum.USER_TYPE_ENUM.AGGIUDICATARIO || role == Enum.USER_TYPE_ENUM.ESECUTORE) {
      // send richiesta to affidatario or to prefettura based on StatoRichiesta
      if (richiesta.StatoRichiesta.Id == Enum.REQUEST_STATE_ENUM.BOZZA ||
        richiesta.StatoRichiesta.Id == Enum.REQUEST_STATE_ENUM.NON_VALIDO) {
        // send to affidatario if current StatoRichiesta is Bozza
        this.sendRichiestaToAffidatario(richiesta)
      }
    }

  }

  /**
  * open send richiesta modal
  * @param richiesta 
  */
  openSendRichiestaModal(richiesta: IRichiesta, documenti: IDocumento[]) {
    //open send richiesta modal
    let sendRichiestaModal = this.dialogService.open(SendRichiestaModalComponent, {
      data: { richiesta, documenti, commessa: this.commessaSelected, isAffidatario: this.isAffidatario },
      header: richiesta.TipoContratto.TipoRichiesta.Nome,
      width: '40%'
    })

    // refresh richieste when modal is closed 
    sendRichiestaModal.onClose.subscribe((richiesta: IRichiesta) => {
      //force refresh 
      if (richiesta && this.richiestaSelected && this.richiestaSelected.Id == richiesta.Id) {
        this.richiestaSelected = null
      }
      this.onRichiestaRowUnselected()
      this.onCommessaRowSelected(this.commessaSelected)
    })
  }

  /**
   * Send richiesta to Affidatario
   * @param richiesta 
   */
  private sendRichiestaToAffidatario(richiesta: IRichiesta) {
    this.alertUtil.showConfirmationAlert("LBL_RICHIESTA_SEND_TO_AFFIDATARIO", null, null, null, null, () => {
      // set StatoRichiesta to IN_LAVORAZIONE
      richiesta.StatoRichiesta.Id = Enum.REQUEST_STATE_ENUM.IN_LAVORAZIONE
      richiesta.StatoRichiesta.Nome = Enum.REQUEST_STATE_NAME_ENUM.IN_LAVORAZIONE

      //save richiesta
      Loading.isLoading = true
      let reqBuilderPath = richiesta.Cantiere ? ['Cantiere', 'TipoContratto', 'StatoRichiesta'] : ['TipoContratto', 'StatoRichiesta', 'Commessa']
      let reqBuilder = new RequestBuilder(richiesta, reqBuilderPath)
      this.richiestaService.changeStatusRichiesta(reqBuilder).pipe(finalize(() => {
        Loading.isLoading = false
      })).subscribe(
        response => {
          if (response.data) {
            this.cd.markForCheck();
            this.alertUtil.showAlert("LBL_RICHIESTA_SENT_TO_AFFIDATARIO", null, null, null, () => {
              //force refresh richieste table
              this.onRichiestaRowUnselected()
              this.onCommessaRowSelected(this.commessaSelected)
            })
          }
          else if (response.error) {
            let errorKey = "LBL_ERROR_" + response.error.Code
            this.alertUtil.showErrorAlert(errorKey)
            if (response.error.Code == 326) {
              //force refresh richieste table when error code is 326
              this.onRichiestaRowUnselected()
              this.onCommessaRowSelected(this.commessaSelected)
            }
          }
          else {
            this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
          }
        },
        error => {
          let errorKey = "LBL_HTTP_ERROR_0"
          if (error.status) {
            errorKey = "LBL_HTTP_ERROR_" + error.status
          }
          this.alertUtil.showErrorAlert(errorKey)
        }
      )
    })
  }

  /**
   * read documento Selected and set Risposta Custom for all questions
   */
  createCustomResponse() {
    let storicoRisposte = this.documentoSelected.StoricoRisposte //get storico risposte array
    let matrDomande = this.documentoSelected.MatriceModulo.MatriceDomande //get matrice domande array
    if (matrDomande) {
      for (let i = 0; i < matrDomande.length; i++) { // iterate matrice domande
        let matriceDomanda = matrDomande[i]
        if (storicoRisposte) {
          for (let y = 0; y < storicoRisposte.length; y++) { // iterate storico risposte
            let storicoRisp = storicoRisposte[y]
            if (storicoRisp.Domanda_Id == matriceDomanda.Id) { // if answer for this question set rispostaCustom to matrice domanda
              matriceDomanda.RispostaCustom = storicoRisp
              break;
            }
          }
          if (!matriceDomanda.RispostaCustom) { // if matrice domanda has no risposta custom set empty risposta
            let storicoEmpty: IStoricoRisposte = {
              Domanda_Id: matriceDomanda.Id,
              Valore: null,
              Placeholder: null,
              Valido: null
            }
            matriceDomanda.RispostaCustom = storicoEmpty
          }
        }
      }
    }
  }

  /**
   * Click on button to show PDF
   * @param documento 
   */
  onClickShowPDF(documento: IDocumento) {

    Loading.isLoading = true

    let documentoCloned: IDocumento = {
      Id: documento.Id,
      Nome: documento.Nome,
      Descrizione: documento.Descrizione,
      Tipologia: documento.Tipologia,
      Data_scadenza: documento.Data_scadenza,
      Documento: documento.Documento,
      DocumentoCreato: documento.DocumentoCreato,
      Autore: documento.Autore,
      Versione: -1
    }

    let reqBuilder = new RequestBuilder(documentoCloned)
    this.documentiService.showPDF(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        //Remove row selected
        this.richiestaTableSelectedItem = []
        this.cd.markForCheck();

        if (response && response["error"] == null) {
          Util.showPdf(response)
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + JSON.stringify(response.error.Stack))
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      }
    )
  }

  /**
   * callback fired when duplicate button is clicked
   * @param documento 
   */
  onDuplicateButtonClicked(documento: IDocumento) {
    this.alertUtil.showConfirmationAlert("LBL_NEW_DOCUMENT", null, null, null, null, () => {

      //save richiesta
      Loading.isLoading = true
      let reqBuilder = new RequestBuilder({ Id: documento.Id })
      this.documentiService.createNewDocumento(reqBuilder).pipe(finalize(() => {
        Loading.isLoading = false
      })).subscribe(
        response => {
          if (response.data) {
            this.cd.markForCheck();
            this.callRichiestaFetchSingle(this.richiestaSelected)
          }
          else if (response.error) {
            let errorKey = "LBL_ERROR_" + response.error.Code
            this.alertUtil.showErrorAlert(errorKey)
            console.log("ERROR: " + response.error.Stack)
          }
          else {
            this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
          }
        },
        error => {
          let errorKey = "LBL_HTTP_ERROR_0"
          if (error.status) {
            errorKey = "LBL_HTTP_ERROR_" + error.status
          }
          this.alertUtil.showErrorAlert(errorKey)
        }
      )
    })
  }


  onInfoValidazione(richiesta: IRichiesta) {

    this.translate.get(["LBL_NOTA_RIFIUTO"]).subscribe(res => {

      let noteModal = this.dialogService.open(NoteModalComponent, {
        data: { richiesta, readOnly: true },
        header: res["LBL_NOTA_RIFIUTO"],
        width: '40%'
      })
      noteModal.onClose.subscribe((notaValidazione: string) => { })
    })

  }

  /**
   * callback fired when delete button is clicked
   * @param richiesta 
   */
  onDeleteRichiesta(richiesta: IRichiesta) {
    // richiesta censimento cannot be delete for !admin
    if (!this.isAdmin && richiesta.TipoContratto.TipoRichiesta.Id == Enum.REQUEST_TYPE_ENUM.CENSIMENTO) {
      this.alertUtil.showAlert("LBL_DELETE_RICHIESTA_CENSIMENTO")
    } else {
      this.alertUtil.showConfirmationAlert("LBL_DELETE_RCHIESTA_CONFIRMATION", null, null, null, null, () => {

        //save richiesta
        Loading.isLoading = true
        let reqBuilder = new RequestBuilder({ Id: richiesta.Id })
        this.richiestaService.deleteRichiesta(reqBuilder).pipe(finalize(() => {
          Loading.isLoading = false
        })).subscribe(
          response => {
            if (response.data) {
              this.cd.markForCheck();
              this.richiestaSelected = null
              // show message and refresh richieste
              this.alertUtil.showAlert("LBL_DELETE_RCHIESTA", null, null, null, () => {
                this.onCommessaRowSelected(this.commessaSelected)
              })
            }
            else if (response.error) {
              let errorKey = "LBL_ERROR_" + response.error.Code
              this.alertUtil.showErrorAlert(errorKey)
              console.log("ERROR: " + response.error.Stack)
            }
            else {
              this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
            }
          },
          error => {
            let errorKey = "LBL_HTTP_ERROR_0"
            if (error.status) {
              errorKey = "LBL_HTTP_ERROR_" + error.status
            }
            this.alertUtil.showErrorAlert(errorKey)
          }
        )
      })
    }
  }

  /**
   * open new page with link address
   * @param commessa 
   */
  goToGISPage(commessa: ICommessa) {
    let linkGIS = commessa.LinkGIS
    if (linkGIS.indexOf("http://") == -1 && linkGIS.indexOf("https://") == -1) {
      linkGIS = "http://" + linkGIS
    }
    window.open(linkGIS, "_blank");
  }

  /**
   * check if new richiesta can be created for the commessa selectec
   */
  private checkRichiestaCreation() {
    this.canCreateRichiesta = true
  }

  /**
   * open modal for associate Gruppo/Commessa
   */
  openAssociaGruppoModal() {
    let commessaGruppoModal = this.dialogService.open(AssociaCommessaAGruppoModalComponent, {
      data: {
        commesse: this.commesse
      },
      header: "Associa Commesse a Gruppo",
      width: '80%'
    })

    commessaGruppoModal.onClose.subscribe((data) => {
      if (data) {
        this.getAllCommesse()
      }
    })
  }


  /**
     * get all esecutori
     */
  getAllEsecutori(tipiRichiesta: ITipoRichiesta[]) {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder({})
    this.esecutoreService.fetchEsecutori(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          let esecutori = response.data
          this.cd.markForCheck();
          this.openRichiestaModal(tipiRichiesta, esecutori);
        } else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  private openRichiestaModal(tipiRichiesta: ITipoRichiesta[], esecutori: IEsecutore[]) {
    this.translate.get("LBL_NEW_RICHIESTA").subscribe(res => {
      //open richiesta modal
      let richiestaModal = this.dialogService.open(RichiestaModalComponent, {
        data: {
          commessa: this.commessaSelected,
          tipiRichiesta: tipiRichiesta,
          currentEsecutori: esecutori //esecutori for modal
        },
        header: res,
        width: '50%'
      });

      // refresh richieste when modal is closed and newRichiesta is created
      richiestaModal.onClose.subscribe((newRichiesta) => {
        if (newRichiesta) {
          //force refresh richieste table
          this.onCommessaRowSelected(this.commessaSelected);
          this.checkRichiestaCreation();
        }
      });
    });
  }
}
